export default "__VITE_ASSET__DsUFwKcL__"